import 'autotrack'
import '../node_modules/autotrack/lib/plugins/event-tracker'
import '../node_modules/autotrack/lib/plugins/outbound-link-tracker'
import '../node_modules/autotrack/lib/plugins/url-change-tracker'

var titles = {
  behindtheclosetdoor: "Behind the Closet Door",
  diaryofanant: "Diary of an Ant",
  inoneearandouttheother: "In One Ear \u0026 Out the Other",
  mythos: "Mythos",
  swimandgoseek: "Swim \u0026 Go Seek",
  thesuperlatives: "The Superlatives",
  wheels: "Wheels"
}

function addPageViewOnHashChange() {

  var title = (function (h) {
        // Mythos, story p2
        if (h[0].match(/intro/) !== null) {
          return "Welcome"
        } else {
          return titles[h[0]]
            + ', ' + h[1].slice(1, -2) // drop the index
            + ' p' + parseInt(h[1].slice(-2)) + 1
        }
      }(location.hash.slice(1).split('-')))

  if (location.hash !=  '') {
    var fieldObject = {
      hitType: 'pageview',
      page: location.hash,
      title:  title,
    }
    document.title = 'Semaphore Studios :: ' + fieldObject['title']

    //console.log(fieldObject)
    ga('send', fieldObject)
  }
}
window.addEventListener('load', () => {
  window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;

  ga('create', 'UA-98439879-1', 'auto')
  // Only require the plugins you've imported above.
  ga('require', 'eventTracker')
  ga('require', 'outboundLinkTracker')
  ga('require', 'urlChangeTracker')
  ga('require', 'linkid')

  ga('send', 'pageview')
  window.addEventListener("hashchange", addPageViewOnHashChange, false)

  // register the page change once loaded
  document.addEventListener("DOMContentLoaded", addPageViewOnHashChange,
    false)
})




/* vim: set ts=2 ss=2 sw=2 et :  */



// WEBPACK FOOTER //
// ./webpack/ganalytics.js